import CryptoJS from 'crypto-js'

const PROTECTED_KEYS: string[] = [
  'token',
  'dataInfoFileMitra',
  'kt-auth-react-v',
  'apiToken',
  'role',
  'lastUserId',
] //key localstorage yg akan diencrypt
const SECRET_KEY_NAME = 'talenta-lpdp.kemenkeu.go.id' //key secret
let secret = sessionStorage.getItem(SECRET_KEY_NAME)

if (!secret) {
  secret = CryptoJS.lib.WordArray.random(32).toString()
  sessionStorage.setItem(SECRET_KEY_NAME, secret)
}

function encryptString(plain: string): string {
  return CryptoJS.AES.encrypt(plain, secret as string).toString()
}

function decryptString(cipherText: string): string | null {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, secret as string)
    const plain = bytes.toString(CryptoJS.enc.Utf8)
    return plain || null
  } catch {
    return null
  }
}

const _origSet = Storage.prototype.setItem
const _origGet = Storage.prototype.getItem

Storage.prototype.setItem = function (key: string, value: string): void {
  try {
    if (PROTECTED_KEYS.includes(key) && value != null) {
      const enc = encryptString(value)
      return _origSet.call(this, key, enc)
    }
  } catch (e) {
    console.error('secure setItem failed:', e)
  }
  return _origSet.call(this, key, value)
}

Storage.prototype.getItem = function (key: string): string | null {
  try {
    const raw = _origGet.call(this, key)
    if (raw == null) return raw
    if (PROTECTED_KEYS.includes(key)) {
      const dec = decryptString(raw)
      return dec !== null ? dec : raw
    }
    return raw
  } catch (e) {
    console.error('secure getItem failed:', e)
    return _origGet.call(this, key)
  }
}
